
import ReactDOM from 'react-dom/client';
import { useEffect, useState } from "react";
import {AppLink as Link, AppWrapper, HeaderView, FooterView, ShadowRoot} from "../components/helpers";
import app from "../components/app";
import Editor from "./editor";
import Preview from "./preview";
import config from "../config";



const AddPage = function({title, data, close, callback}) {
   const [item, setItem] = useState(data?data:app.defaultData("pageKeys"));

   const save = function(){
    if(item["name"] === "") {
      alert("Enter valid page name!");
      return false;
    }
    if(item["url"] === "") {
      alert("Enter valid page URL!");
      return false;
    }
    app.fetchPost({
      ...item,
      "method":item.id?"update":"insert"
    }).then(function(response){
      console.log(response);
      alert("Page information successfully saved and updated!");
      callback(item);
    })
   }
   const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    if(id === "status") {
      setItem({
        ...item,
        status: e.target.getAttribute("data-value") === "true"?true:false,
      });
    }
    else {
      setItem({
        ...item,
        [id]: type === 'checkbox' ? checked : value,
      });
    }
  };
  console.log(item);
  return <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="addPageModalLabel">{title}</h5>
        <button type="button" className="btn-close" onClick={() => close()} />
      </div>
      <div className="modal-body">

          {/* Basic Info */}
          {
              config.pageKeys.map(function(v){
                let input = <input type="text" id={v.key} className="form-control" value={item[v.key]} onChange={handleChange} placeholder={v.placeholder} />
                if(v.type === "textarea") {
                  input = <textarea className="form-control" id={v.key} placeholder={v.placeholder.toString()} value={item[v.key]} onChange={handleChange} />
                }
                if(v.type === "select") {
                  input = <select className="form-control" id={v.key} value={item[v.key]} onChange={handleChange}>
                    {
                      v.options.map(function(val){
                        return  <option value={val.value}>{val.text}</option>
                      })
                    }
                   
                  </select>
                }
                if(v.type === "tabs") {
                  input =  <div className="btn-group">
                    {
                      v.options.map(function(val){
                        let active = "";
                        if(val.value === item[v.key]) {
                          active = "active";
                        }
                        return <button type="button" id={v.key} onClick={handleChange} data-value={val.value} className={`btn btn-outline-primary ${active}`}>{val.text}</button>
                      })
                    }
                  </div>
                }
               
                return  <div className={`mb-3 ${v.type === "textarea"?"":"d-flex"} ${v.type === "hidden"?"d-none":""}`} key={v.key}>
                  <label className="form-label w-25">{v.text}</label>
                  <div className={`${v.type === "textarea"?"w-100":"w-75"}`}>{input}</div>
                </div>
              })
            }
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={() => close()}>Cancel</button>
        <button type="button" className="btn btn-primary" onClick={save}>Save</button>
      </div>
    </div>
  </div>

}

const copyClipboard = function(copyText) {
    var input = document.createElement("input");
    input.value = copyText;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    alert("Copied: " + copyText);
}








export default function Pages(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [page, setPage] = useState("");
    const [type, setType] = useState("");
    const config = app.getConfig();
    
    useEffect(() => {
      app.fetchPost({
      "method":"list"
    }).then(function(response){
      if(response.data.results) {
        const results = response.data.results.filter(function(v){
          if(v.type === "header" || v.type === "footer") {
            return false;
          }
          return true;
        })
        setData(results);
        localStorage.setItem("pages", JSON.stringify(results.map(function(v){
          return {
            name:v.name,
            url:v.url
          }
        })))
      }
    }); 
    }, []);

    const updateItem = function(key, value) {
        let itemData = JSON.parse(JSON.stringify(item));
        itemData[key] = value;
        setItem(itemData);
    }

    const saveItem = function(item, mode) {
        const postData = {
            "method":"savePages",
            "title":item.title,
            "page":item.page,
            "category":item.category,
            "status":item.status,
            "data":JSON.stringify(item.data)
        }
        if(item.id) {
            postData["id"] = item.id;
        }
        app.fetchPost(postData, mode).then(function(response){
            if(!item.id) {
                if(response.data._id) {
                    window.pushState("pages", response.data._id);
                }
                else {
                    //window.location.reload();
                }
            }
          //  console.log("response", response);
        })
    }
    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this Page")) {
            app.fetchPost({
                "method":"delete",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }
    
    
    const defaultItem = function(index) {
        //{"method":"addIdentifierInPage","aiPageId":"65533bdf961e425f01267724","aiPageIdenfier":"website"}

        app.fetchPost({
            "method":"addIdentifierInPage",
            "aiPageId":data[index].id,
            "aiPageIdenfier":"website"
        }).then(function(response){
             console.log("response", response)
        })
    }

    const addPage = function(index) {
        const div = document.createElement("div");
        
        div.setAttribute("class", "modal fade show d-block");
        div.setAttribute("style", `background:rgba(0, 0 ,0 ,0.5)`);

        document.body.appendChild(div);
        const divPopup = ReactDOM.createRoot(div);
        divPopup.render(<AddPage data={index === undefined?null:data[index]} title={index === undefined?"Add Page":"Update Page"} close={function(){
          div.remove()
        }} callback={function(item){
          setData(data.map(function(v, i){
            if(i === index) {
              return item;
            }
            return v;
          }))
          div.remove();
        }} />, div);
    }

    

   
    return <AppWrapper>
     
<div className="container">
  <h3 className="mb-4">Header</h3>
   <ShadowRoot text="Edit Header" domain={props.domain} id="header">
<HeaderView />
  </ShadowRoot>
  
  <h3 className="mb-4">Pages <button className="btn btn-success float-end" onClick={() => addPage()}>+ Add New Page</button></h3>


  {
    data.map(function(v, i){
      return  <div className="page-card">
    <div>
      <div className="fw-bold">🛠️ {v.name}</div>
      <small className="text-muted">URL: /{v.url} &nbsp; | &nbsp; Type: {v.type}</small>
    </div>
    <div>
      <button className="btn btn-sm btn-outline-primary me-1" onClick={() => app.htmlPreview(v)} >Preview</button>
      <button className="btn btn-sm btn-outline-warning me-1" onClick={() => addPage(i)}>Edit Info</button>

      <a className="btn btn-sm btn-outline-warning me-1" href={`/${props.domain}/${v.id}`} >Edit</a>
      <button className="btn btn-sm btn-outline-danger" onClick={() => deleteItem(i)}>Delete</button>
    </div>
  </div>
    })
     
  }

  {/* Home */}
  <div className="page-card d-none">
    <div>
      <div className="fw-bold">🏠 Home</div>
      <small className="text-muted">URL: / &nbsp; | &nbsp; Type: Static</small>
    </div>
    <div>
      <button className="btn btn-sm btn-outline-primary me-1">Preview</button>
      <button className="btn btn-sm btn-outline-warning me-1">Edit</button>
      <button className="btn btn-sm btn-outline-danger">Delete</button>
    </div>
  </div>
  {/* Services */}

  {/* Subpages under Services */}
  <div className="sub-list d-none">
    <div className="page-card">
      <div>
        <div className="fw-bold">🌐 Web Design</div>
        <small className="text-muted">URL: /services/web-design</small>
      </div>
      <div>
        <button className="btn btn-sm btn-outline-primary me-1">Preview</button>
        <button className="btn btn-sm btn-outline-warning me-1">Edit</button>
        <button className="btn btn-sm btn-outline-danger">Delete</button>
      </div>
    </div>
    <div className="page-card">
      <div>
        <div className="fw-bold">📈 SEO</div>
        <small className="text-muted">URL: /services/seo</small>
      </div>
      <div>
        <button className="btn btn-sm btn-outline-primary me-1">Preview</button>
        <button className="btn btn-sm btn-outline-warning me-1">Edit</button>
        <button className="btn btn-sm btn-outline-warning me-1">Edit</button>
        <button className="btn btn-sm btn-outline-danger">Delete</button>
      </div>
    </div>
  </div>

  
  <h3 className="mb-4">Footer</h3>
  <ShadowRoot text="Edit Footer" domain={props.domain} id="footer">
<FooterView />
  </ShadowRoot>
  

</div>



    </AppWrapper>
}